import React from 'react'
import { Input } from 'reactstrap'
import Isvg from 'react-inlinesvg';
import eyeIcon from '../../assets/svg/eye.svg';

/**
 * 
 * @param {import('../types').FormV2FieldProps} param0 
 */
const PasswordV2Field = ({
    field,
    value,
    onChange,
    onBlur,
    onFocus,
    isRequired,
    isDisabled,
    errorMessage,
    classes,
    styles,
    placeholder,
    lang,
    aria,
    id,
    name,
    valid,
    hasError,
}) => {
    const [type, setType] = React.useState('password');

    return (
        <div className='formV2-field-input-password-wrapper'>
            <Input
                id={id}
                name={name}
                type={type}
                placeholder={placeholder?.translate(lang)}
                value={value}
                onChange={e => onChange?.(e.target.value)}
                onBlur={onBlur}
                onFocus={onFocus}
                disabled={isDisabled}
                required={isRequired}
                invalid={hasError}
                valid={valid}
                {...aria || {}}
                className={`formV2-field-input-password ${hasError || valid ? 'formV2-field-input-password-error' : ''} ${classes?.field}`}
                style={styles?.field}
                autoComplete={field?.config?.autoComplete}
            />
            <button
                type='button'
                className={`formV2-field-input-password-toggle ${hasError || valid ? 'formV2-field-input-password-toggle-error' : ''}`}
                onClick={() => setType(prev => prev === 'password' ? 'text' : 'password')}
            >
                <Isvg src={eyeIcon} />
            </button>
        </div>
    )
}

export default PasswordV2Field